
/*
	This is the browser-side replacement for the Mongo ObjectId, which is unavailable
	in the browser.

	TODO replace uses of Id with BrowserId.
*/

export class BrowserId
{
	constructor(
		readonly value:string
	){}

	toString() { return this.value; }

	valueOf()  { return this.value; }
}
